module.exports = __webpack_public_path__ + "img/ticketwin.09090c6b.svg";